<template>
  <div class="quiz-category-list">
    <div class="begin">
        <div class="flex items-center justify-end mr-4 -mb-6">
          <div class="update mr-4 hover-icon" @click.stop="editCategory">
            <svg-icon
              name="ic_update"
              original
              class="w-4 h-4 cursor-pointer"
            />
          </div>
          <div class="delete hover-icon" @click.stop="openDeleteConfirm">
            <svg-icon
              name="ic_delete-red"
              original
              class="w-4 h-4 cursor-pointer"
            />
          </div>
        </div>
      <div class="debt border flex items-center justify-between rounded-2xl p-6 mb-8 cursor-pointer" @click="$emit('openQuizList')">
        <div class="part-1 flex items-center">
          <div class="image mr-8 h-16 w-16 p-4 rounded-lg">
            <svg-icon :name="quizCategoryList.icon" original class="w-8 h8" />
          </div>
          <div class="title text-black font-medium text-lg w-3/4 leading-relaxed">{{ quizCategoryList.label }}</div>
        </div>
        <div class="part-2 mr-8">
          <svg-icon
            name="ic_arrow-right"
            original
            class="w-4 h-4"
          />
        </div>
      </div>
    </div>
    <!-- EDIT CATEGORY MODAL -->
    <create-categorie
      :show="showEditModal"
      :edit-data="quizCategoryList"
      @close="closeEditModal"
      @categoryCreated="onCategoryUpdated"
    />
    <!-- DELETE CONFIRMATION MODAL -->
    <confirm-delete-category
      :show="showDeleteConfirm"
      :category-name="quizCategoryList.label"
      @confirm="deleteCategory"
      @cancel="closeDeleteConfirm"
    />
  </div>
</template>

<script>
import CreateCategorie from '@/components/helper/quiz/create-categorie'
import ConfirmDeleteCategory from '@/components/helper/quiz/confirm-delete-category'

export default {
  name: 'quiz-category-list',
  components: {
    CreateCategorie,
    ConfirmDeleteCategory
  },
  props: {
    quizCategoryList: {
      type: Object,
      default: function () {
        return {
        }
      }
    }
  },
  data () {
    return {
      showEditModal: false,
      showDeleteConfirm: false
    }
  },
  methods: {
    editCategory () {
      this.showEditModal = true
    },
    closeEditModal () {
      this.showEditModal = false
    },
    onCategoryUpdated () {
      this.$emit('categoryUpdated')
    },
    openDeleteConfirm () {
      this.showDeleteConfirm = true
    },
    closeDeleteConfirm () {
      this.showDeleteConfirm = false
    },
    deleteCategory () {
      this.$emit('deleteCategory', this.quizCategoryList.id)
      this.closeDeleteConfirm()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "src/assets/style/sass/variables";
  .image {
    background-color: rgba(19, 168, 192, 0.15);
  }

  .hover-icon {
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.7;
    }
  }
</style>
